import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ModalForgotPassword, ChangePassword, SentEmail } from './forgotPassword.styles';

//import useHandleEmail from 'src/hooks/useHandleEmail'

export default function ForgotPassword(props) {
  const [forgotPassword, setForgotPassword] = useState(props.showModalForgotPassword);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setForgotPassword(props.showModalForgotPassword);
  }, [props.showModalForgotPassword]);

  const closeModal = () => setForgotPassword(false);

  const sendEmailToServer = async () => {
    try {
      setVisible(true);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <ModalForgotPassword showModalForgotPassword={forgotPassword}>
      <div>
        <div>
          <h3>¿Olvidate tu contaseña?</h3>
          <figure onClick={closeModal}>
            <img
              src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/icon_modal_close.png`}
              alt="icono para cerrar la ventana"
            />
          </figure>
        </div>
        {visible === false ? (
          <ChangePassword>
            <p>
              Para cambiar tu contraseña, por favor ingresa el correo registrado en{' '}
              <span>FinSphera</span>
            </p>
            <input />
            <button onClick={sendEmailToServer}>Enviar</button>
          </ChangePassword>
        ) : (
          <SentEmail>
            <p>
              Se ha enviado un correo a la cuenta <span>micorreo@empresa.mx</span> con un enlace
              para cambiar tu contraseña. Por favor revisa tu buzón de entrada (y spam) y haz clic
              en el enlace, o puedes copiarlo y pegarlo en el navegador. Luego podrás cambiar tu
              contraseña.
            </p>
            <Link to="/cambiar-contraseña">Cerrar</Link>
          </SentEmail>
        )}
      </div>
    </ModalForgotPassword>
  );
}
